/**
 * Object xử lý event global trên toàn bộ hệ thống
 * @author DNThang - 17.03.2020
 */

import Vue from 'vue';
const EventBusGlobal = new Vue();

export default EventBusGlobal;

/**
 * Đối tượng liệt kê các global event đang có
 * Bắt buộc có globalEvent nào đều phải cấu hình vào đây để không bị trùng tên
 * @author DNThang - 17.03.2020
 */
const GlobalEventName = {
	/**
	 * Xử lý đóng tất form
	 */
	closeAllPopup: 'closeAllPopup',
	scrollEvent: 'scrollEvent',
	reloadList: 'reloadList',
	resetPopupCenter: 'resetPopupCenter',
	setWaitingConfirm: 'setWaitingConfirm',
	showHelpViewHistory: 'showHelpViewHistory',
	sortEvent: 'sortEvent',
	closeAllDropdown: 'closeAllDropdown',
	checkTaxDeclarationProcedure: 'checkTaxDeclarationProcedure',
	checkTaxPaymentProcedure: 'checkTaxPaymentProcedure',
	closeSuggest: 'closeSuggest',
	resetInfoEsign: 'resetInfoEsign',
	// Kích hoạt mở popup đăng nhập MISA eSign từ luồng cấp bù CTS khi đã ở màn hình kết nối
	openConnectEsignPopup: 'openConnectEsignPopup',
		openCompensCertChangeService: 'openCompensCertChangeService',

	// Export notification events
	exportNotification: 'exportNotification', // Khi nhận được SignalR notification về export
	addDownloadTask: 'addDownloadTask', // Khi thêm task download mới vào manager
	removeDownloadTask: 'removeDownloadTask', // Khi xóa task download khỏi manager
	updateDownloadProgress: 'updateDownloadProgress', // Cập nhật tiến trình download

    // Sự kiện ký số từ xa async
    signingCompleted: 'signingCompleted', // Khi nhận được SignalR notification ký số hoàn thành

    // Sự kiện MISA Notification v2 incident
	ShowMisaIncidentNotification: 'ShowMisaIncidentNotification', // Khi có/thay đổi incident notification in-app

	// MISA Notification In-App v2 hiển thị/ẩn — banner license ẩn/hiện theo (ưu tiên MISA notif)
	misaNotifVisible: 'misaNotifVisible', // payload: true (show) / false (hide)

	// Thực hiện logout
	logoutAmis: 'logoutAmis',

	// Sự kiện AMIS Convert
	amisConvertCompleted: 'amisConvertCompleted', // Nhận SignalR thông báo nâng cấp AMIS hoàn thành
	amisConvertFailed: 'amisConvertFailed', // Nhận SignalR thông báo lỗi chung khi convert AMIS thất bại
	amisConvertUserInactive: 'amisConvertUserInactive', // Nhận SignalR thông báo user AMIS bị ngừng kích hoạt/thùng rác
	amisUserDataChanged: 'amisUserDataChanged', // Nhận SignalR thông báo dữ liệu user/user_role thay đổi → yêu cầu reload
}

export { GlobalEventName };
